import { apiPost, apiGet, apiDelete, apiPut } from '../utils/api'
import Hotjar from '@hotjar/browser'

export const acceptHeadsetAPI = (config) => {
  Hotjar.event('accept_headset')
  return apiPost(`mgmt/headset/accept/`, config)
}

export const getHeadsetAPI = () => {
  return apiGet(`mgmt/headset/current/`)
}

export const headsetEnableSyncAPI = (config) => {
  Hotjar.event('sync_headset')
  return apiPost(`mgmt/headset/${config.id}`, config)
}

// weedmaps
export const getWeedmapAccountAPI = () => {
  return apiGet(`mgmt/thirdparty/weedmap`)
}

export const createWeedmapAccountAPI = (data) => {
  Hotjar.event('create_weedmap_account')
  return apiPost(`mgmt/thirdparty/weedmap`, data)
}

export const updateWeedmapAPIKeyAPI = (config) => {
  Hotjar.event('update_weedmap_key')
  return apiPut(`mgmt/thirdparty/weedmap/apiKey`, config)
}

export const updateWeedmapAccountAPI = (config) => {
  Hotjar.event('update_weedmap_account')
  return apiPut(`mgmt/thirdparty/weedmap`, config)
}

export const deleteWeedmapAccountAPI = () => {
  Hotjar.event('delete_weedmap_account')
  return apiDelete(`mgmt/thirdparty/weedmap`)
}

export const syncWeedmapMenuAPI = () => {
  Hotjar.event('sync_weedmap_menu')
  return apiPost(`mgmt/thirdparty/weedmap/sync`)
}

export const resetSyncWeedmapMenuAPI = () => {
  Hotjar.event('reset_sync_weedmap_menu')
  return apiPost(`mgmt/thirdparty/weedmap/resetonly`)
}

export const resetAndDeleteWeedmapAPI = () => {
  Hotjar.event('reset_and_delete_weedmap')
  return apiPost(`mgmt/thirdparty/weedmap/reset`)
}

export const discontinueWeedmapsItemsAPI = (data) => {
  Hotjar.event('discontinue_weedmaps_items')
  return apiPost(`mgmt/thirdparty/weedmap/discontinueItems`, data)
}

export const generateTokenAPI = (data) => {
  return apiGet(`mgmt/thirdparty/weedmap/generate`, data)
}

export const renewTokenAPI = (data = {}) => {
  Hotjar.event('renew_weedmap_token')
  return apiPost(`mgmt/thirdparty/weedmap/token`, data)
}

export const getWeedmapTagsAPI = () => {
  return apiGet(`mgmt/thirdparty/weedmap/tags`)
}

// webhooks

export const getWebHooksAPI = () => {
  return apiGet('partner/webHooks')
}

export const updateWebHookAPI = (data) => {
  Hotjar.event('update_webhook')
  return apiPut(`partner/webHooks/${data.id}`, data)
}

export const createWebHookAPI = (data) => {
  Hotjar.event('create_webhook')
  return apiPost(`partner/webHooks`, data)
}

// onFleet

export const getHubListAPI = (apiKey) => {
  return apiGet('mgmt/onfleet/hub', { apiKey: apiKey })
}

export const updateShopOnFleetSettingsAPI = (onFleetSettings) => {
  Hotjar.event('update_shop_onfleet_setting')
  return apiPost(`mgmt/onfleet/shop/${onFleetSettings.shopId}/settings`, onFleetSettings)
}

export const updateShopOnFleetKeyAPI = (onFleetShop) => {
  Hotjar.event('update_shop_onfleet_key')
  return apiPost(`mgmt/onfleet/shop/${onFleetShop.shopId}`, onFleetShop)
}

export const getEmployeeListAPI = () => {
  return apiGet('mgmt/employees/employeeList')
}

export const getOnFleetTeamsAPI = () => {
  return apiGet('mgmt/onfleet/onFleetTeamsByCompany')
}

export const getWorkersByTeamOnFleetAPI = (teamId, shopId) => {
  return apiGet(`mgmt/onfleet/team/${teamId}/workers`, { shopId })
}

export const updateEmployeeOnFleetAPI = ({ id, shopId, teamId }) => {
  Hotjar.event('update_employee_onfleet')
  return apiPost(`mgmt/onfleet/employee/${id}/team`, { shopId, teamId })
}

export const syncEmployeeOnFleetAPI = ({ id, shopId, workerIds, teamId }) => {
  Hotjar.event('sync_employee_onfleet')
  return apiPost(`mgmt/onfleet/employee/${id}`, { shopId, workerIds, teamId })
}

export const createWorkerOnFleetAPI = ({ id, shopId, teamId }) => {
  Hotjar.event('create_worker_onfleet')
  return apiPost(`mgmt/onfleet/employee/${id}/worker`, { shopId, teamId })
}

export const onFleetTeamsByShopAPI = (data) => {
  return apiGet('mgmt/onfleet/onFleetTeamsByShop', data)
}

export const onFleetErrorLogByShopAPI = (data) => {
  return apiGet('mgmt/onfleet/shop/onFleetErrorLog', data)
}

export const synchronizeTeamsAPI = (data) => {
  Hotjar.event('sync_onfleet_teams')
  return apiPost('mgmt/onfleet/synchronizeTeam', data)
}

export const removeWorkerOnFleetAPI = ({ id, shopId, teamId }) => {
  Hotjar.event('remove_worker_onfleet')
  return apiPost(`mgmt/onfleet/employee/${id}/team/remove`, { shopId, teamId })
}

export function getSpringBigListAPI(data) {
  return apiGet('mgmt/springbig/list')
}

export function createSpringBigInfoAPI(data) {
  Hotjar.event('create_spingbig_info')
  return apiPost('mgmt/springbig/create', data)
}

export function updateSpringBigInfoAPI(data) {
  return apiPut('mgmt/springbig/update', data)
}

export function syncSpringBigMembersAPI(data) {
  Hotjar.event('sync_springbig_members')
  return apiPost(`mgmt/springbig/sync?shopId=${data.shopId}&source=${data.source}`, data.fields)
}

export function getLastSyncSpringbigAPI() {
  return apiGet(`mgmt/springbig/sync/last`)
}

export function getTookanAccountListAPI(data) {
  return apiGet('mgmt/tookan', data)
}

export function createTookanAccountAPI(data) {
  Hotjar.event('create_tookan_account')
  return apiPost('mgmt/tookan', data)
}

export function updateTookanAccountAPI(data) {
  Hotjar.event('update_tookan_account')
  return apiPut(`mgmt/tookan/${data.id}`, data)
}

export function deleteTookanAccountAPI(accountId) {
  Hotjar.event('delete_tokan_account')
  return apiDelete(`mgmt/tookan/${accountId}`)
}

export function updateAgentWithTookanAPI(employeeId, data) {
  Hotjar.event('update_agent_with_tokaan')
  return apiPost(`mgmt/tookan/employee/${employeeId}`, data)
}

export function createAgentWithTookanAPI(employeeId, data) {
  Hotjar.event('create_agent_with_tokaan')
  return apiPost(`mgmt/tookan/employee/${employeeId}/agent`, data)
}

export function getTookanTeamsAPI(data) {
  return apiGet(`mgmt/tookan/teams/list`, data)
}

export function syncTeamWithTookanAPI(shopId) {
  Hotjar.event('sync_team_with_tookan')
  return apiPost(`mgmt/tookan/syncTeam`, { shopId })
}

export function getTookanErrorLogsAPI(shopId) {
  return apiGet(`mgmt/tookan/errorLogs`, { shopId })
}

export function updateWeedmapMappingAPI(data) {
  Hotjar.event('update_weedmap_mapping')
  return apiPut(`mgmt/thirdparty/weedmap/mapping`, data)
}

export function getSpenceAccountListAPI(companyId) {
  return apiGet(`mgmt/spence?companyId=${companyId}`)
}

export function createSpenceAccountAPI(data) {
  Hotjar.event('create_spence_account')
  return apiPost('mgmt/spence', data)
}

export function updateSpenceAccountAPI(data) {
  Hotjar.event('update_spence_account')
  return apiPut(`mgmt/spence/${data.id}`, data)
}

export function deleteSpenceAccountAPI(accountId) {
  Hotjar.event('delete_spence_account')
  return apiDelete(`mgmt/spence/${accountId}`)
}

export function getACHAccountListAPI(companyId) {
  //return apiGet(`mgmt/ach/achaccount?companyId=${companyId}`);

  return apiGet(`mgmt/ach/shopachaccount?companyId=${companyId}`)
}

export function createACHAccountAPI(data) {
  Hotjar.event('create_ach_account')
  return apiPost('mgmt/ach/shopachaccount', data)
}

export function updateACHAccountAPI(data) {
  Hotjar.event('update_ach_account')
  return apiPut(`mgmt/ach/shopachaccount/${data.id}`, data)
}

export function deleteACHAccountAPI(accountId) {
  Hotjar.event('delete_ach_account')
  return apiDelete(`mgmt/ach/shopachaccount/${accountId}`)
}



// WEBPACK FOOTER //
// ./src/api/integration.js